import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';

var StyledFlex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledInputWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var StyledButtonWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 0.8rem;\n  width: 10rem;\n"], ["\n  margin-left: 0.8rem;\n  width: 10rem;\n"])));
var StyledDescriptionWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 0.2rem;\n"], ["\n  margin-top: 0.2rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { StyledButtonWrapper, StyledDescriptionWrapper, StyledFlex, StyledInputWrapper };
